// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2zc_R","errors":"Errors_errors__1l-Pu"};